import { AriaDatapoint } from './AriaDatapoint';

export default class DevOnlyDatapoint extends AriaDatapoint {
    public getEventType(): string {
        return 'client_event_dev_only';
    }
}
